import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
  Navigate,
} from "react-router-dom";
import Header from "./components/home/Header/Header";
import SignIn from "./pages/Account/SignIn";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Shop from "./pages/Shop/Shop";
import ErrorPage from "./pages/Error";
import ScrollToTop from "./components/designLayouts/buttons/ScrollTop";
import ProtectedRoute from "./utils/ProtectedRoute";
import OrderHistory from "./pages/Orders/OrdersHistory";
import UnpaidInvoices from "./pages/Invoices/UnpaidInvoices";
import OrderDetail from "./pages/Orders/OrderDetail";
import { ToastContainer } from "react-toastify";
import Breadcrumb from "./components/designLayouts/Breadcrumb";
const Layout = () => {
  return (
    <div>
      <Header />
      <Breadcrumb />
      <ScrollRestoration />
      <Outlet />
      <ScrollToTop />
      <ToastContainer />
    </div>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<ErrorPage />}>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/shop" replace />} />
        {/* Protected routes */}
        <Route
          path="/shop"
          element={
            <ProtectedRoute>
              <Shop />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/:_id"
          element={
            <ProtectedRoute>
              <ProductDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <OrderHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/:orderId"
          element={
            <ProtectedRoute>
              <OrderDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoices"
          element={
            <ProtectedRoute>
              <UnpaidInvoices />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="*" element={<ErrorPage />} />
    </Route>,
  ),
);

function App() {
  return (
    <div className="font-bodyFont">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
